import { graphql, useStaticQuery } from 'gatsby'

const toDate = node => new Date(node.frontmatter.date)

const sortByDate = (a, b) => toDate(b) - toDate(a)

export const useGetWhatsNews = ({ slug }) => {
  const [lang, appname] = slug.split('/', 5).slice(2, 4)

  const data = useStaticQuery(graphql`
    query whatsnewNavQuery {
      allMdx(filter: { fields: { slug: { glob: "/whatsnew/**" } } }) {
        nodes {
          fields {
            slug
          }
          frontmatter {
            title
            app
            date
            description
          }
        }
      }
    }
  `)
  return data.allMdx.nodes
    .filter(({ fields: { slug } }) =>
      slug.startsWith(`/whatsnew/${lang}/${appname}`)
    )
    .sort(sortByDate)
}
